import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const RowsComponent = (props) => {
  const { rows } = props || {};

  return rows?.map((row) => (
    <TableRow
      key={row.name}
      sx={{
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }}
    >
      <TableCell component='th' scope='row'>
        {row.leadStatus}
      </TableCell>
      <TableCell align='right'>{row.autoService}</TableCell>
      <TableCell align='right'>{row.reco}</TableCell>
      <TableCell align='right'>{row.total}</TableCell>
    </TableRow>
  ));
};

export default RowsComponent;
